var makeString = require('./helper/makeString');

module.exports = function replaceAll(str, find, replace, ignorecase) {
  var flags = (ignorecase === true)?'gi':'g';
  var reg = new RegExp(find, flags);

  return makeString(str).replace(reg, replace);
};



//////////////////
// WEBPACK FOOTER
// ../~/underscore.string/replaceAll.js
// module id = 760
// module chunks = 0